import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../store/ui';
import * as fromAuth from '../../../../store/auth';
import { UiState } from '../../../../store/ui';
import { AuthState } from '../../../../store/auth';
import { Router } from '@angular/router';
import { TrackingService } from 'src/app/modules/shared/services/tracking.service';
import * as fromEvents from '../../tracking/events';

@Component({
    selector: 'app-customer-header',
    templateUrl: './customer-header.component.html',
    styleUrls: ['./customer-header.component.scss'],
    standalone: false
})
export class CustomerHeaderComponent implements OnInit, OnDestroy {
  locations$ = this.store.select(fromAuth.selectAvailableLocations);
  featuresCount$ = this.store.select(fromAuth.selectRecentFeaturesCount);
  selectedLocationId$ = this.store.select(fromStore.selectSelectedLocationId);

  constructor(
    private store: Store<{ ui: UiState; auth: AuthState }>,
    private router: Router,
    private tracking: TrackingService,
  ) {}

  ngOnInit(): void {}

  ngOnDestroy() {}

  selectLocation(locationId: number, locationName: string) {
    this.tracking.track(fromEvents.locationPicked({ location: locationName }));
    if (this.router.url.startsWith('/user')) return this.router.navigate(['locations', locationId, 'overview']);
    else if (this.router.url.startsWith('/locations/')) {
      const baseUrlParts = this.router.url.split('?');
      const urlParts = baseUrlParts[0].split('/');
      urlParts[2] = String(locationId);
      this.router.navigateByUrl([urlParts.join('/'), ...baseUrlParts.slice(1)].join('?'));
    }
  }

  showOnboarding() {
    this.store.dispatch(fromAuth.loadFeatures({for: 'Recent'}));
  }
}
